import styled from 'styled-components';
import { select } from '../../../core/themev2';

const MenuOption = styled.div`
  font-family: Hind;
  font-size: 14px;
  font-weight: ${({ isSelected }) => (isSelected ? '600' : '400')};
  line-height: 25.62px;
  color: ${select('black')};
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-top: 3%;
  padding-bottom: 2%;
  padding-left: 3%;
  width: 100%;
`;

const DropDownOption = styled.div`
  width: 100%;
  position: absolute;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 258px;
  background-color: ${select('white')};
  box-shadow: 0px 4px 11px 9px rgba(166, 166, 166, 0.05);
  border: 1px solid ${select('midLightGray')};
  border-radius: 8px;
  padding: 8px 0;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  margin-top: -24px;
  &::-webkit-scrollbar {
    width: 8px;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${select('midLightGray')};
    border-radius: 8px;
  }
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  top: 24px;
  z-index: 90;
`;

export { MenuOption, DropDownOption };
